module.exports = {};



//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/~/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = 0